var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 126,
    viewBox: "0 0 127 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4104_172)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 126,
    height: 126,
    fill: "url(#pattern0)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4104_172",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4104_172"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 126,
    height: 126,
    fill: "white",
    transform: "translate(0.5)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_4104_172",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAACPUlEQVR4nO2VwYrFMAwD+/8/vXveFF4QkhM9dgZ6imvLmUKfH6jiuR0A/oKQMhBSBkLKQEgZCCkDIWVshTzPc/Rx5+/eb9sPIWX7IaRsP4SU7WcLSZO+0PS5C0LC5y4ICZ+7ICR87nJciPtTc/u73N7vVd8eGCFlgRFSFhgh7YERUhYYIWWBEVIWGCF3A7vC0vMRgpCuwAgpC4wQs6HK9IWn50/3R0jbfumGKghZ6tMNVRCy1KsNpx91ofT56f0QUrYfQsr2Q0jZfrKQNtQFv42v2wghZSCkjH8vRP4pXf7puz95tf74Tx0hCEGIE8gNiJClXzqQGlidf/oDSefZ5lUXcs8RssmrLuSeI2STV13IPUfIJq+6kFp/Wmh6vruvfH/qQDeg2h8hZmCEIGR0vrvvuBD3QtIXkM6vzkMIQhCCECFPOr8677oQtV5dKH2ucv0DijdEiJUPIWZ+td+2Pt4QIVY+f4NhpoXsBLiPnEd+4zAIKQMhZSDkcGD1wt16t596roIQhCDk431vCxDSLSTNtBB1/mnhr/5q4DQIWfqrgdMgZOmvBk6DkKW/GtgNeLq/iytYnucOQIhX/3rfHYAQr/71vjsAIV796313wGkh03nV/ukPAiEI8fpP51X7I2Q4r9r/3wlJ19fPcwMhJDzPDYSQ8Dw3EELC89KBVNIL375whCAkC0KW/unAKghZ+k8HcAO7H8T0BaZBCEIQ8jHvtgAhRzk/ET6CkDIQUgZCykBIGQgpAyFlIKSMX7/TVdG9MvM/AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qr-code.c0dd2c383b50962481f55a04d876010d.svg";
export { ForwardRef as ReactComponent };